import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Button from '@mui/material/Button';
import Grid from '@mui/material/GridLegacy';
import Typography from '@mui/material/Typography';
import { useContext } from 'react';
import { useNavigate } from 'react-router';
import { BentleySystemsLogo } from '../../../assets/BentleySystemsLogo';
import { SeequentLogo } from '../../../assets/SeequentLogo';
import { LOGOUT_ROUTE } from '../../../constants';
import { isLoggedInWithBentleyToken } from '../../../store/sessionStorageHelpers/accessTokenHelper/accessTokenHelper';
import { INCORRECT_IDENTITY_PROVIDER_BENTLEY, INCORRECT_IDENTITY_PROVIDER_SEEQUENT, LOGOUT, } from '../../../strings';
import { LoginContext } from '../../loginHandler/LoginContext';
import { Background } from '../Background';
import { useStyles } from '../Background.styles';
export function CentralBackground({ children, correctIdentityProvider = true, }) {
    const navigate = useNavigate();
    const { imageList } = useContext(LoginContext);
    const { classes } = useStyles({ imageList });
    const isLoggedInWithBentley = isLoggedInWithBentleyToken();
    return (_jsxs(Background, { children: [children, !correctIdentityProvider && (_jsxs(Grid, { container: true, direction: "column", justifyContent: "center", className: classes.signInBox, children: [isLoggedInWithBentley ? (_jsx(SeequentLogo, { className: classes.logo })) : (_jsx(BentleySystemsLogo, { className: classes.logo })), _jsx(Typography, { className: classes.text, children: isLoggedInWithBentley
                            ? INCORRECT_IDENTITY_PROVIDER_SEEQUENT
                            : INCORRECT_IDENTITY_PROVIDER_BENTLEY }), _jsxs(Button, { variant: "contained", size: "large", onClick: () => navigate(LOGOUT_ROUTE), children: [LOGOUT, " of ", isLoggedInWithBentley ? 'Bentley Account' : 'Seequent ID'] })] }))] }));
}
//# sourceMappingURL=CentralBackground.js.map